module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiExtIt.32df3ec.ttf";